const rocketStrings = window.rocketStrings || {};
window.RocketPopupGift = (() => {
  const attribute = '_rocket_popup_glow_balls';
  const reward = 'glow_balls_20261030';
  const sticks = [47715152330979, 47715152363747];
  const balls = 49442699804899;
  const root = window.Shopify?.routes?.root || '/';
  const quantityOf = (items, ids) => items.reduce((total, item) => total + (ids.includes(Number(item.variant_id || item.id)) ? Number(item.quantity) || 0 : 0), 0);
  const entitled = (cart) => cart.attributes?.[attribute] === reward;

  async function prepareItems(items) {
    if (!quantityOf(items, sticks)) return;
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(rocketStrings.retryError || 'Please try again.');
    const cart = await response.json();
    if (!entitled(cart)) return;
    const desired = Math.max(1, Math.floor((quantityOf(cart.items, sticks) + quantityOf(items, sticks)) / 2));
    const needed = Math.max(0, desired - quantityOf(cart.items, [balls]));
    for (let index = items.length - 1; index >= 0; index -= 1) {
      if (Number(items[index].id) === balls) items.splice(index, 1);
    }
    if (needed) items.push({ id: balls, quantity: needed, properties: { _rocket_popup_gift: reward } });
  }

  async function reconcile(cart, sections) {
    if (!entitled(cart)) return cart;
    const updates = {};
    const paidSticks = quantityOf(cart.items, sticks);
    const desired = paidSticks ? Math.max(1, Math.floor(paidSticks / 2)) : 0;
    let remaining = desired;
    cart.items.forEach((item) => {
      if (Number(item.variant_id) !== balls || item.properties?._rocket_popup_gift !== reward) return;
      const quantity = Math.min(item.quantity, remaining);
      remaining -= quantity;
      if (quantity !== item.quantity) updates[item.key] = quantity;
    });
    if (!Object.keys(updates).length) return cart;
    const response = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates, sections, sections_url: window.location.pathname }),
    });
    if (!response.ok) throw new Error(rocketStrings.retryError || 'Please try again.');
    return response.json();
  }

  async function ensureCheckout() {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(rocketStrings.retryError || 'Please try again.');
    let cart = await response.json();
    if (!entitled(cart)) return;
    cart = await reconcile(cart, []);
    const count = quantityOf(cart.items, sticks);
    const desired = count ? Math.max(1, Math.floor(count / 2)) : 0;
    const needed = Math.max(0, desired - quantityOf(cart.items, [balls]));
    if (!needed) return;
    const added = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: balls, quantity: needed, properties: { _rocket_popup_gift: reward } }] }),
    });
    if (!added.ok) throw new Error(rocketStrings.retryError || 'Please try again.');
  }

  if (typeof document !== 'undefined') document.addEventListener('submit', async (event) => {
    const form = event.target;
    const button = event.submitter;
    if (button?.name !== 'checkout' || form.dataset.rocketGiftReady) return;
    let claimed = false;
    try {
      const saved = JSON.parse(window.localStorage.getItem('rocket_hockey_popup_v1') || 'null');
      claimed = saved?.claim?.entitlementValue === reward;
    } catch (_) {}
    if (!claimed) return;
    event.preventDefault();
    button.disabled = true;
    try {
      await ensureCheckout();
      button.disabled = false;
      form.dataset.rocketGiftReady = 'true';
      form.requestSubmit(button);
    } catch (error) {
      button.disabled = false;
      const message = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
      if (message) message.textContent = error.message;
    } finally {
      delete form.dataset.rocketGiftReady;
    }
  }, true);

  return { prepareItems, reconcile, ensureCheckout };
})();
if (!customElements.get('rocket-product')) {
  customElements.define(
    'rocket-product',
    class RocketProduct extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.form = this.querySelector('[data-rocket-product-form]');
        this.submitButton = this.querySelector('[data-rocket-cta]');
        this.message = this.querySelector('[data-rocket-message]');
        this.quantityInput = this.querySelector('[data-rocket-quantity]');
        this.lineQuantityInput = this.querySelector('[data-rocket-line-quantity]');
        this.variantIdInput = this.querySelector('[data-rocket-variant-id]');
        this.paymentTermsVariantInput = this.querySelector('[data-rocket-payment-variant-id]');
        this.cart = document.querySelector('cart-drawer');
        this.currency = window.Shopify?.currency?.active || 'CAD';
        this.locale = document.documentElement.lang || 'en-CA';

        try {
          this.variants = JSON.parse(this.querySelector('[data-rocket-variants]')?.textContent || '[]');
          this.config = JSON.parse(this.querySelector('[data-rocket-config]')?.textContent || '{}');
        } catch (error) {
          console.error('Rocket product configuration could not be loaded.', error);
          return;
        }

        this.querySelectorAll('[data-rocket-option]').forEach((input) => {
          input.addEventListener('change', () => this.onOptionChange());
        });
        this.querySelectorAll('[data-rocket-side]').forEach((input) => {
          input.addEventListener('change', () => this.onSideChange(input));
        });
        this.querySelectorAll('[data-rocket-offer]').forEach((input) => {
          input.addEventListener('change', () => this.onOfferChange());
        });
        this.querySelectorAll('[data-quantity-change]').forEach((button) => {
          button.addEventListener('click', () => this.changeQuantity(Number(button.dataset.quantityChange)));
        });
        this.quantityInput?.addEventListener('change', () => this.normalizeQuantity());
        this.querySelectorAll('[data-rocket-thumb]').forEach((button) => {
          button.addEventListener('click', () => this.changeMedia(button));
        });
        this.querySelector('[data-rocket-gallery-previous]')?.addEventListener('click', () => this.moveGallery(-1));
        this.querySelector('[data-rocket-gallery-next]')?.addEventListener('click', () => this.moveGallery(1));
        this.querySelector('[data-rocket-gallery-play]')?.addEventListener('click', () => this.playGalleryVideo());
        this.enableGallerySwipe();
        this.form?.addEventListener('submit', (event) => this.onSubmit(event));

        this.updateOfferSelection();
        this.updateTotals();
      }

      get selectedOffer() {
        return this.querySelector('[data-rocket-offer]:checked');
      }

      get selectedVariant() {
        return this.variants.find((variant) => String(variant.id) === String(this.variantIdInput?.value));
      }

      get selectedLineVariants() {
        const groups = Array.from(this.querySelectorAll('[data-rocket-side-group]')).slice(0, this.getUnitCount());
        if (groups.length) {
          return groups
            .map((group) => group.querySelector('[data-rocket-side]:checked')?.dataset.variantId)
            .map((id) => this.variants.find((variant) => String(variant.id) === String(id)))
            .filter(Boolean);
        }
        const variant = this.selectedVariant;
        return variant ? Array.from({ length: this.getUnitCount() }, () => variant) : [];
      }

      money(cents, includeCurrency = true) {
        try {
          const formatted = new Intl.NumberFormat(this.locale, {
            style: 'currency',
            currency: this.currency,
            currencyDisplay: 'narrowSymbol',
          }).format((Number(cents) || 0) / 100);
          return includeCurrency ? `${formatted} ${this.currency}` : formatted;
        } catch (_error) {
          return `${((Number(cents) || 0) / 100).toFixed(2)} ${this.currency}`;
        }
      }

      formatTestMoney(cents, includeCurrency = true) {
        return this.money(cents, includeCurrency);
      }

      compactMoney(cents) {
        try {
          return new Intl.NumberFormat(this.locale, {
            style: 'currency',
            currency: this.currency,
            currencyDisplay: 'narrowSymbol',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          }).format((Number(cents) || 0) / 100);
        } catch (_error) {
          return this.money(cents, false).replace(/([.,])00(?=\D*$)/, '');
        }
      }

      getTestPricing(offerValue = this.selectedOffer?.value) {
        const isDuo = offerValue === 'duo';
        const currencyPricing = this.config.testPricingByCurrency?.[this.currency] || {};
        const price = Number(
          isDuo
            ? currencyPricing.duo || this.config.duoTestPriceCents
            : currencyPricing.starter || this.config.starterTestPriceCents,
        );
        const configuredCompare = Number(
          isDuo ? this.config.duoTestCompareCents : this.config.starterTestCompareCents,
        );
        const regularTotal = Number(this.selectedVariant?.price || 0) * (isDuo ? 2 : 1);
        return {
          price,
          compare: configuredCompare > price
            ? configuredCompare
            : (regularTotal > price ? regularTotal : 0),
        };
      }

      getUnitCount() {
        return Math.max(1, Number(this.selectedOffer?.dataset.unitCount || 1));
      }

      getBundleQuantity() {
        return Math.max(1, Number(this.quantityInput?.value || 1));
      }

      normalizeQuantity() {
        const minimum = Number(this.quantityInput?.min || 1);
        const maximum = Number(this.quantityInput?.max || 20);
        const next = Math.min(maximum, Math.max(minimum, Math.round(Number(this.quantityInput?.value) || minimum)));
        this.quantityInput.value = next;
        this.updateTotals();
      }

      changeQuantity(change) {
        if (!this.quantityInput) return;
        this.quantityInput.value = this.getBundleQuantity() + change;
        this.normalizeQuantity();
      }

      onOptionChange() {
        const selectedValues = Array.from(this.querySelectorAll('[data-option-position]')).map(
          (fieldset) => fieldset.querySelector('[data-rocket-option]:checked')?.value,
        );
        const variant = this.variants.find(
          (candidate) => candidate.options?.every((value, index) => value === selectedValues[index]),
        );

        this.querySelectorAll('[data-rocket-option]').forEach((input) => {
          input.closest('.rocket-choice')?.classList.toggle('is-selected', input.checked);
        });

        if (!variant) {
          this.variantIdInput.value = '';
          this.updateVariantState(null);
          return;
        }

        this.variantIdInput.value = variant.id;
        this.updateVariantState(variant);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }

      onSideChange(input) {
        const group = input.closest('[data-rocket-side-group]');
        group?.querySelectorAll('[data-rocket-side]').forEach((sideInput) => {
          sideInput.closest('.rocket-side-card')?.classList.toggle('is-selected', sideInput.checked);
        });

        if (input.dataset.stickIndex === '1') {
          const variant = this.variants.find((candidate) => String(candidate.id) === String(input.dataset.variantId));
          if (!variant) return;
          this.variantIdInput.value = variant.id;
          this.updateVariantState(variant);
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);

          if (input.dataset.mediaSrc) {
            const media = this.querySelector('[data-rocket-main-media]');
            if (media) {
              this.resetGalleryVideo();
              media.src = input.dataset.mediaSrc;
              media.srcset = '';
              media.alt = input.closest('.rocket-side-card')?.querySelector('strong')?.textContent.trim() || '';
              this.querySelector('[data-rocket-gallery]')?.classList.remove('is-lifestyle');
              const sparksBadge = this.querySelector('[data-rocket-sparks-badge]');
              if (sparksBadge) sparksBadge.hidden = true;
            }
          }
        } else {
          this.updateTotals();
        }
      }

      updateVariantState(variant) {
        const price = this.querySelector('[data-rocket-current-price]');
        const compare = this.querySelector('[data-rocket-compare-price]');
        const savings = this.querySelector('[data-rocket-save]');
        const stock = this.querySelector('[data-rocket-stock]');
        const isAvailable = Boolean(variant?.available);

        if (variant) {
          this.updatePaymentTerms(variant);
          if (!this.config.testPricingEnabled) {
            if (price) price.textContent = this.money(variant.price);
            const hasComparison = Number(variant.compare_at_price) > Number(variant.price);
            if (compare) {
              compare.textContent = hasComparison ? this.money(variant.compare_at_price, false) : '';
              compare.classList.toggle('is-hidden', !hasComparison);
            }
            if (savings) {
              savings.textContent = hasComparison ? `${this.compactMoney(variant.compare_at_price - variant.price)} ${rocketStrings.off}` : '';
              savings.classList.toggle('is-hidden', !hasComparison);
            }
          }
        }

        if (stock) {
          stock.textContent = isAvailable ? stock.dataset.inStock || rocketStrings.inStock : this.config.soldOut;
          stock.classList.toggle('rocket-stock--out', !isAvailable);
          if (stock.hasAttribute('data-sold-out-only')) stock.hidden = isAvailable;
        }
        this.updateTotals(variant);
      }

      updatePaymentTerms(variant) {
        if (!this.paymentTermsVariantInput || !variant) return;
        this.paymentTermsVariantInput.value = variant.id;
        this.paymentTermsVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
        this.querySelector('shopify-payment-terms')?.setAttribute('variant-id', variant.id);
      }

      onOfferChange() {
        this.updateOfferSelection();
        this.updateTotals();
      }

      updateOfferSelection() {
        this.querySelectorAll('[data-rocket-offer]').forEach((input) => {
          input.closest('.rocket-offer')?.classList.toggle('is-selected', input.checked);
        });
        const secondSide = this.querySelector('[data-rocket-side-group="2"]');
        if (secondSide) {
          const showSecondSide = this.getUnitCount() > 1;
          secondSide.hidden = !showSecondSide;
          secondSide.setAttribute('aria-hidden', String(!showSecondSide));
        }
      }

      updateTotals(variant = this.selectedVariant) {
        if (!variant) {
          const label = this.querySelector('[data-rocket-cta-label]');
          const total = this.querySelector('[data-rocket-cta-price]');
          if (label) label.textContent = this.config.unavailable || rocketStrings.unavailable;
          if (total) total.textContent = '';
          return;
        }

        this.querySelectorAll('[data-offer-price]').forEach((element) => {
          const offer = element.closest('[data-rocket-offer-card]')?.querySelector('[data-rocket-offer]')?.value;
          if (this.config.testPricingEnabled) {
            const offerPricing = this.getTestPricing(offer);
            element.textContent = this.formatTestMoney(offerPricing.price);
            const offerCompare = element.closest('.rocket-offer__pricing')?.querySelector('[data-offer-compare]');
            if (offerCompare) {
              offerCompare.textContent = offerPricing.compare
                ? this.formatTestMoney(offerPricing.compare, false)
                : '';
              offerCompare.classList.toggle('is-hidden', !offerPricing.compare);
            }
          } else {
            const units = Number(element.dataset.unitCount || 1);
            const nativeDiscount = units >= 2 ? Number(this.config.nativeDuoDiscountPerStick || 0) * units : 0;
            element.textContent = this.money(Math.max(0, variant.price * units - nativeDiscount), false);
          }
        });

        const selectedVariants = this.selectedLineVariants;
        const selectionsAvailable = selectedVariants.length === this.getUnitCount() && selectedVariants.every((item) => item.available);
        const lineQuantity = this.getUnitCount() * this.getBundleQuantity();
        const bundlePrice = selectedVariants.reduce((totalPrice, item) => totalPrice + Number(item.price || 0), 0);
        const nativeDiscount = selectedVariants.length >= 2
          ? Number(this.config.nativeDuoDiscountPerStick || 0) * selectedVariants.length
          : 0;
        const nativeBundlePrice = Math.max(0, bundlePrice - nativeDiscount);
        const bundleCompare = selectedVariants.reduce((totalPrice, item) => {
          const itemPrice = Number(item.price || 0);
          const itemCompare = Number(item.compare_at_price || 0);
          return totalPrice + Math.max(itemPrice, itemCompare);
        }, 0);
        const displayPricing = this.config.testPricingEnabled
          ? this.getTestPricing()
          : {
              price: nativeBundlePrice,
              compare: bundleCompare > nativeBundlePrice ? bundleCompare : 0,
            };
        const price = this.querySelector('[data-rocket-current-price]');
        const compare = this.querySelector('[data-rocket-compare-price]');
        const savings = this.querySelector('[data-rocket-save]');
        const installment = this.querySelector('[data-rocket-test-installment]');
        if (price) price.textContent = this.money(displayPricing.price);
        if (compare) {
          compare.textContent = displayPricing.compare
            ? this.money(displayPricing.compare, false)
            : '';
          compare.classList.toggle('is-hidden', !displayPricing.compare);
        }
        if (savings) {
          const savedAmount = displayPricing.compare - displayPricing.price;
          savings.textContent = displayPricing.compare
            ? (this.config.testPricingEnabled ? `${rocketStrings.save} ${this.compactMoney(savedAmount)}` : `${this.compactMoney(savedAmount)} ${rocketStrings.off}`)
            : '';
          savings.classList.toggle('is-hidden', !displayPricing.compare);
        }
        if (installment) installment.textContent = this.money(Math.ceil(displayPricing.price / 4));

        if (this.lineQuantityInput) this.lineQuantityInput.value = lineQuantity;
        const label = this.querySelector('[data-rocket-cta-label]');
        const total = this.querySelector('[data-rocket-cta-price]');
        if (label) label.textContent = selectionsAvailable ? this.config.addToCart : this.config.soldOut;
        if (total) {
          total.textContent = this.config.testPricingEnabled
            ? this.formatTestMoney(this.getTestPricing().price * this.getBundleQuantity())
            : this.money(nativeBundlePrice * this.getBundleQuantity(), false);
        }
        if (this.submitButton) this.submitButton.disabled = !selectionsAvailable;
      }

      changeMedia(button) {
        const media = this.querySelector('[data-rocket-main-media]');
        if (!media || !button.dataset.src) return;
        this.resetGalleryVideo();
        const isVideo = button.dataset.mediaType === 'video';
        media.src = button.dataset.src;
        media.srcset = '';
        media.alt = button.dataset.alt || '';
        this.querySelector('[data-rocket-gallery]')?.classList.toggle('is-lifestyle', button.dataset.lifestyle === 'true');
        this.querySelector('[data-rocket-gallery]')?.classList.toggle('is-video', isVideo);
        const playButton = this.querySelector('[data-rocket-gallery-play]');
        if (playButton) playButton.hidden = !isVideo;
        const sparksBadge = this.querySelector('[data-rocket-sparks-badge]');
        if (sparksBadge) sparksBadge.hidden = button.dataset.showSparks !== 'true';
        this.querySelectorAll('[data-rocket-thumb]').forEach((thumbnail) => {
          thumbnail.classList.toggle('is-active', thumbnail === button);
        });
        button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      resetGalleryVideo() {
        const video = this.querySelector('[data-rocket-gallery-video]');
        if (video) {
          video.pause();
          video.hidden = true;
        }
        const media = this.querySelector('[data-rocket-main-media]');
        if (media) media.hidden = false;
        const playButton = this.querySelector('[data-rocket-gallery-play]');
        if (playButton) playButton.hidden = true;
        this.querySelector('[data-rocket-gallery]')?.classList.remove('is-video');
      }

      playGalleryVideo() {
        const video = this.querySelector('[data-rocket-gallery-video]');
        if (!video) return;
        let shouldLoad = false;
        video.querySelectorAll('source[data-src]').forEach((source) => {
          if (!source.hasAttribute('src')) {
            source.src = source.dataset.src;
            shouldLoad = true;
          }
        });
        if (shouldLoad) video.load();
        video.hidden = false;
        const media = this.querySelector('[data-rocket-main-media]');
        if (media) media.hidden = true;
        const playButton = this.querySelector('[data-rocket-gallery-play]');
        if (playButton) playButton.hidden = true;
        video.focus({ preventScroll: true });
        video.play().catch(() => {
          if (playButton) playButton.hidden = false;
        });
      }

      moveGallery(direction) {
        const thumbnails = Array.from(this.querySelectorAll('[data-rocket-thumb]'));
        if (!thumbnails.length) return;
        const currentIndex = Math.max(0, thumbnails.findIndex((thumbnail) => thumbnail.classList.contains('is-active')));
        const nextIndex = (currentIndex + direction + thumbnails.length) % thumbnails.length;
        this.changeMedia(thumbnails[nextIndex]);
      }

      enableGallerySwipe() {
        const gallery = this.querySelector('[data-rocket-gallery]');
        if (!gallery) return;

        let gesture = null;
        const clearGesture = () => {
          gesture = null;
          gallery.classList.remove('is-dragging');
        };

        gallery.addEventListener('dragstart', (event) => event.preventDefault());
        gallery.addEventListener('pointerdown', (event) => {
          if (event.target.closest('button, video') || (event.pointerType === 'mouse' && event.button !== 0)) return;
          gesture = { pointerId: event.pointerId, x: event.clientX, y: event.clientY };
          gallery.classList.add('is-dragging');
          gallery.setPointerCapture?.(event.pointerId);
        });
        gallery.addEventListener('pointerup', (event) => {
          if (!gesture || event.pointerId !== gesture.pointerId) return;
          const horizontalDistance = event.clientX - gesture.x;
          const verticalDistance = event.clientY - gesture.y;
          if (Math.abs(horizontalDistance) >= 45 && Math.abs(horizontalDistance) > Math.abs(verticalDistance) * 1.15) {
            this.moveGallery(horizontalDistance < 0 ? 1 : -1);
          }
          clearGesture();
        });
        gallery.addEventListener('pointercancel', clearGesture);
        gallery.addEventListener('lostpointercapture', clearGesture);
      }

      setLoading(isLoading) {
        if (!this.submitButton) return;
        this.submitButton.toggleAttribute('aria-disabled', isLoading);
        this.submitButton.classList.toggle('is-loading', isLoading);
        const spinner = this.submitButton.querySelector('.rocket-loading');
        if (spinner) spinner.hidden = !isLoading;
      }

      showMessage(text, isError = false) {
        if (!this.message) return;
        this.message.textContent = text;
        this.message.hidden = !text;
        this.message.classList.toggle('is-error', isError);
      }

      async onSubmit(event) {
        event.preventDefault();
        const selectedVariants = this.selectedLineVariants;
        if (
          selectedVariants.length !== this.getUnitCount() ||
          selectedVariants.some((variant) => !variant.available) ||
          this.submitButton?.hasAttribute('aria-disabled')
        ) return;

        this.setLoading(true);
        this.showMessage('');
        const offerName = this.selectedOffer?.closest('.rocket-offer')?.querySelector('.rocket-offer__title')?.textContent.trim();
        const groupedVariants = selectedVariants.reduce((groups, variant) => {
          const key = String(variant.id);
          groups[key] = groups[key] || { variant, count: 0 };
          groups[key].count += 1;
          return groups;
        }, {});
        const items = Object.values(groupedVariants).map(({ variant, count }) => ({
          id: variant.id,
          quantity: count * this.getBundleQuantity(),
          properties: offerName && this.config.offerProperty ? { [this.config.offerProperty]: offerName } : {},
        }));

        const giftCount = Number(this.selectedOffer?.dataset.giftCount || 0) * this.getBundleQuantity();
        if (this.dataset.giftEnabled === 'true' && this.config.giftVariantId && giftCount > 0) {
          items.push({ id: this.config.giftVariantId, quantity: giftCount });
        }

        const payload = { items };
        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
          this.cart.setActiveElement(this.submitButton);
        }

        try {
          await window.RocketPopupGift.prepareItems(items);
          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || rocketStrings.addError);

          if (this.cart && result.sections) {
            this.cart.renderContents(result);
          } else {
            window.location.assign(window.routes?.cart_url || '/cart');
          }
        } catch (error) {
          this.showMessage(error.message || rocketStrings.retryError, true);
        } finally {
          this.setLoading(false);
        }
      }
    },
  );
}

if (!customElements.get('rocket-product-tabs')) {
  customElements.define(
    'rocket-product-tabs',
    class RocketProductTabs extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.tabs = Array.from(this.querySelectorAll('[data-rocket-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-rocket-tab-panel]'));

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activateTab(tab.dataset.rocketTab));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
        });

        document.querySelectorAll('[data-rocket-reviews-link]').forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            this.activateTab('reviews');
            this.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        });
      }

      activateTab(name, focus = false) {
        const activeTab = this.tabs.find((tab) => tab.dataset.rocketTab === name) || this.tabs[0];
        if (!activeTab) return;
        this.tabs.forEach((tab) => {
          const isActive = tab === activeTab;
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
          tab.classList.toggle('is-active', isActive);
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.rocketTabPanel !== activeTab.dataset.rocketTab;
        });
        if (focus) activeTab.focus();
        window.dispatchEvent(new Event('resize'));
      }

      onKeydown(event, tab) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const currentIndex = this.tabs.indexOf(tab);
        let nextIndex = event.key === 'ArrowLeft' ? currentIndex - 1 : currentIndex + 1;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        nextIndex = (nextIndex + this.tabs.length) % this.tabs.length;
        this.activateTab(this.tabs[nextIndex].dataset.rocketTab, true);
      }
    },
  );
}

if (!customElements.get('rocket-demo-modal')) {
  customElements.define(
    'rocket-demo-modal',
    class RocketDemoModal extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.openButton = this.querySelector('[data-rocket-demo-open]');
        this.closeButton = this.querySelector('[data-rocket-demo-close]');
        this.modal = this.querySelector('[data-rocket-video-modal]');
        this.video = this.querySelector('[data-rocket-modal-video]');
        this.source = this.video?.querySelector('source[data-src]');

        this.openButton?.addEventListener('click', () => this.open());
        this.closeButton?.addEventListener('click', () => this.close());
        this.modal?.addEventListener('click', (event) => {
          if (event.target === this.modal) this.close();
        });
        this.modal?.addEventListener('close', () => this.pause());
      }

      open() {
        if (!this.modal || !this.video) return;
        if (this.source && !this.source.hasAttribute('src')) {
          this.source.src = this.source.dataset.src;
          this.video.load();
        }
        this.modal.showModal();
        this.video.play().catch(() => {});
      }

      close() {
        if (this.modal?.open) this.modal.close();
      }

      pause() {
        this.video?.pause();
      }
    },
  );
}

if (!customElements.get('rocket-cart-upsell')) {
  customElements.define(
    'rocket-cart-upsell',
    class RocketCartUpsell extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('[data-rocket-upsell-form]');
        this.button = this.querySelector('[data-rocket-upsell-button]');
        this.message = this.querySelector('[data-rocket-upsell-message]');
        this.form?.addEventListener('submit', (event) => this.onSubmit(event));
      }

      async onSubmit(event) {
        event.preventDefault();
        if (this.button?.disabled) return;
        const cartDrawer = this.closest('cart-drawer');
        const payload = { items: [{ id: Number(this.dataset.variantId), quantity: 1 }] };
        if (cartDrawer) {
          payload.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
          cartDrawer.setActiveElement(this.button);
        }

        this.button.disabled = true;
        this.button.classList.add('is-loading');
        if (this.message) this.message.hidden = true;

        try {
          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || rocketStrings.addBallsError);

          if (cartDrawer && result.sections) cartDrawer.renderContents(result);
          else window.location.reload();
        } catch (error) {
          if (this.message) {
            this.message.textContent = error.message || rocketStrings.retryError;
            this.message.hidden = false;
          }
          this.button.disabled = false;
          this.button.classList.remove('is-loading');
        }
      }
    },
  );
}

// Sticky add-to-cart bar: shows whenever the main product CTA is off screen.
(function () {
  const bar = document.querySelector('[data-rocket-sticky-cta]');
  const cta = document.querySelector('[data-rocket-cta]');
  if (!bar || !cta || !('IntersectionObserver' in window)) return;
  const button = bar.querySelector('[data-rocket-sticky-button]');
  const price = bar.querySelector('[data-rocket-sticky-price]');
  const mainPrice = cta.closest('rocket-product')?.querySelector('[data-rocket-current-price]');
  const sync = () => {
    if (mainPrice && price) price.textContent = mainPrice.textContent.trim();
    button.disabled = cta.disabled;
  };
  if (mainPrice && 'MutationObserver' in window) {
    new MutationObserver(sync).observe(mainPrice, { childList: true, characterData: true, subtree: true });
  }
  if ('MutationObserver' in window) {
    new MutationObserver(sync).observe(cta, { attributes: true, attributeFilter: ['disabled'] });
  }
  sync();
  bar.hidden = false;
  const mobile = window.matchMedia('(max-width: 749px)');
  new IntersectionObserver((entries) => {
    const entry = entries[entries.length - 1];
    const visible = entry.isIntersecting;
    // Desktop: show whenever the button is off screen. Mobile: only after scrolling past it.
    const scrolledPast = entry.boundingClientRect.top < 0;
    bar.classList.toggle('is-visible', !visible && (!mobile.matches || scrolledPast));
  }, { threshold: 0.2 }).observe(cta);
  button.addEventListener('click', () => {
    if (cta.disabled) return;
    cta.click();
    cta.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();
